import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/express/express',
    method: 'get',
    params
  })
}

export function getDetail(id, params) {
  return request({
    url: '/express/express/' + id,
    method: 'get',
    params
  })
}

export function updateExpress(id, data) {
  return request({
    url: '/express/express/' + id,
    method: 'put',
    data
  }) 
}

export function createExpress(data) {
  return request({
    url: '/express/express',
    method: 'post',
    data
  }) 
}

export function deleteExpress(id) {
  return request({
    url: '/express/express/' + id,
    method: 'delete'
  }) 
}

export function supplementExpress(data) {
  return request({
    url: '/express/supplement',
    method: 'post',
    data
  })
}